module.exports = __webpack_public_path__ + "img/advantage-pig.b1737550.webp";